import * as React from 'react';

import { applyListPatch } from './list-state';
import type { ListQuery, ListState } from './types';

/**
 * List state in React state: the default when no `list` is passed to
 * `useDataTable`. Use it directly to read the query (for a fetch) or to
 * start from an initial query.
 */
export function useLocalListState(initial: Partial<ListQuery> = {}): ListState {
  const [query, setQuery] = React.useState<ListQuery>(() =>
    applyListPatch({ filters: {} }, initial),
  );
  const update = React.useCallback((patch: Partial<ListQuery>) => {
    setQuery((prev) => applyListPatch(prev, patch));
  }, []);
  return React.useMemo(() => ({ ...query, update }), [query, update]);
}
